import GeneratePDFDownload from "../Shared/GeneratePDFDownload"

export const HIOFDownload = () => {
    return (
        <GeneratePDFDownload url={{ slug: 'major_med_hiof', type: 'case' }} fileName={'major_med_hiof.pdf'} variant={true}>
            <i className="ti ti-printer"></i> HIOF
        </GeneratePDFDownload>
    )
}
